import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WhatsappModalService {
  isOpen = signal(false);
  targetUrl = signal('');

  open(url: string) {
    this.targetUrl.set(url);
    this.isOpen.set(true);
  }

  close() {
    this.isOpen.set(false);
    this.targetUrl.set('');
  }
}
